// this is the number of downloads per week required to see the advertiser things
export const ADVERTISING_OPT_IN_THRESHOLD = 500;
